import { useToast } from '@opoint/infomedia-storybook'
import { useMutation } from '@tanstack/react-query'
import { useCustomAxiosInstance } from '../axios/instance'

const useProfileBackfill = (
  profileId: number | null | undefined,
  onSuccess?: () => void,
) => {
  const apiClient = useCustomAxiosInstance()
  const { toast } = useToast()

  return useMutation<unknown, unknown, { startTime: number; endTime: number }>(
    ({ startTime, endTime }) =>
      apiClient({
        url: `/profiles/${profileId}/backfill/`,
        method: 'post',
        data: {
          start_time: startTime,
          end_time: endTime,
        },
      }),
    {
      onSuccess: () => {
        toast({
          title: 'Query was successfully re-ran.',
          variant: 'success',
        })
        onSuccess?.()
      },
      onError: () =>
        toast({
          title: 'Something went wrong. Please try again.',
          variant: 'error',
        }),
    },
  )
}

export default useProfileBackfill
